// extracted by mini-css-extract-plugin
export default {"container":"JoinPage_container__O+68t","joinTitle":"JoinPage_joinTitle__2xGbd"};